import { BodySBold, HeadingSBold } from 'components/Typography/Typography';
import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/tryAndBuy/tryAndBuyFBBDialogStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

interface FBBPlanProps {
	planType: string;
	planName: string;
	newPlan?: boolean;
}

const PlanCard = (props: FBBPlanProps) => {
	const { planType, planName, newPlan } = props;

	const classes = useStyles();

	const selectClasses = classNames({
		[classes.fbbPlanWrapper]: true,
		[classes.fbbNewPlan]: newPlan,
	});

	return (
		<div className={selectClasses}>
			<BodySBold {...{ color: newPlan ? 'enterprise' : 'disabled-light' }}>{planType}</BodySBold>
			<HeadingSBold {...{ color: newPlan ? 'enterprise' : 'secondary-light' }} disableMargin>
				{planName}
			</HeadingSBold>
		</div>
	);
};
export default PlanCard;
